import type { Quiz, quizScreenType } from "quiz/types/quiz.model";
import {
  DEFAULT_PLAY_BACKGROUND,
  DEFAULT_RED_COLOR,
  DEFAULT_SCREEN_BACKGROUND,
  DEFAULT_WHITE_COLOR,
} from "../_graphic_design";

export const defaultQuizzes: Record<quizScreenType, Omit<Quiz, "id">> = {
  bandeau_horizontal: {
    colors: {
      background: "#02184D",
      buttonBackground: DEFAULT_RED_COLOR,
      buttonBorder: DEFAULT_WHITE_COLOR,
      buttonText: DEFAULT_WHITE_COLOR,
      choiceBackground: DEFAULT_WHITE_COLOR,
      choiceText: "#004179",
      choiceNumber: "#EE3224",
      labels: DEFAULT_WHITE_COLOR,
      questionText: DEFAULT_WHITE_COLOR,
    },
    creationTime: "",
    durations: {
      question: 5,
      choices: 10,
      solution: 5,
      winner: 3,
    },
    endingMobileMsg: "",
    endingMsg: "",
    entity: "",
    hasSeating: true,
    images: {
      gameOverLogo: "/psg/example_player.png",
      playBackground: DEFAULT_PLAY_BACKGROUND,
      questionLogo: "/psg/logo.png",
      registerLogo: "/psg/logo.png",
      screenAnimatedLogo: "/psg/logo.png",
      screenBackground: DEFAULT_SCREEN_BACKGROUND,
      screenBackgroundLeft: "/psg/bg_left.png",
      waitingLogo: "/psg/example_player.png",
      winnerLogo: "/psg/logo.png",
    },
    name: "",
    organization: "",
    questions: [],
    section: "",
    screenType: "bandeau_horizontal" as quizScreenType,
    waitingMsg: "",
    winnerMsg: "",
  },
  "16_9": {
    colors: {
      background: "#02184D",
      buttonBackground: DEFAULT_RED_COLOR,
      buttonBorder: DEFAULT_WHITE_COLOR,
      buttonText: DEFAULT_WHITE_COLOR,
      choiceBackground: DEFAULT_WHITE_COLOR,
      choiceText: "#000000",
      choiceNumber: DEFAULT_WHITE_COLOR,
      labels: DEFAULT_WHITE_COLOR,
      questionText: DEFAULT_WHITE_COLOR,
    },
    creationTime: "",
    durations: {
      question: 5,
      choices: 10,
      solution: 5,
      winner: 3,
    },
    endingMobileMsg: "",
    endingMsg: "",
    entity: "",
    hasSeating: true,
    images: {
      gameOverLogo: "/psg/logo.png",
      playBackground: DEFAULT_PLAY_BACKGROUND,
      questionLogo: "/psg/logo.png",
      registerLogo: "/psg/logo.png",
      screenAnimatedLogo: "/psg/logo.png",
      screenBackground: DEFAULT_SCREEN_BACKGROUND,
      screenBackgroundLeft: "/psg/bg_left.png",
      waitingLogo: "/psg/waiting_logo.png",
      winnerLogo: "/psg/psg-qatar.png",
    },
    name: "",
    organization: "",
    section: "",
    questions: [],
    screenType: "16_9" as quizScreenType,
    waitingMsg: "",
    winnerMsg: "",
  },
};
